import { faReact } from '@fortawesome/free-brands-svg-icons';
import {
	faAngleDown,
	faAngleRight,
	faEllipsis,
	faFileCode,
	faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

function Explorer({ onTabChange, activeTab }) {
	function handleTabClick(tabIndex) {
		onTabChange(tabIndex);
	}

	const [portfolioFolderIsActive, setPortfolioFolderIsActive] = useState(true);

	function handlePortfolioFolder() {
		setPortfolioFolderIsActive((prevValue) => !prevValue);
	}

	return (
		<div className="explorer">
			<h1>
				explorer <FontAwesomeIcon icon={faEllipsis} className="ellipsis" />
			</h1>
			<h2 onClick={handlePortfolioFolder}>
				{portfolioFolderIsActive ? (
					<FontAwesomeIcon icon={faAngleDown} />
				) : (
					<FontAwesomeIcon icon={faAngleRight} />
				)}{' '}
				<span>portfolio</span>
			</h2>
			<div
				className="container-files"
				style={{ visibility: portfolioFolderIsActive ? 'visible' : 'hidden' }}
			>
				<div
					className={`explorer-files ${activeTab === 0 ? 'active' : ''}`}
					onClick={() => handleTabClick(0)}
				>
					<FontAwesomeIcon icon={faReact} style={{ color: '#5CCFEE' }} />
					home.jsx
				</div>

				<div
					className={`explorer-files ${activeTab === 1 ? 'active' : ''}`}
					onClick={() => handleTabClick(1)}
				>
					<FontAwesomeIcon icon={faFileCode} style={{ color: '#CBCA00' }} />
					stack.json
				</div>
				<div
					className={`explorer-files ${activeTab === 2 ? 'active' : ''}`}
					onClick={() => handleTabClick(2)}
				>
					<FontAwesomeIcon icon={faPaperPlane} style={{ color: '#3178C6' }} />
					contact.ts
				</div>
			</div>
		</div>
	);
}

export default Explorer;
